import { render, staticRenderFns } from "./com-form-video.vue?vue&type=template&id=0890238c&scoped=true&"
import script from "./com-form-video.vue?vue&type=script&lang=js&"
export * from "./com-form-video.vue?vue&type=script&lang=js&"
import style0 from "./com-form-video.vue?vue&type=style&index=0&id=0890238c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890238c",
  null
  
)

export default component.exports